import type { HelpConfig } from '#types/config/pages/help'
import type { RecursivePartial } from '#types/utils'

export default {
  brandClasses: {
    main: 'w-full',
    sectionHeading: 'title-1',
  }
} satisfies RecursivePartial<HelpConfig>
